(() => {
  const root = document.querySelector('[data-gk-pdp]');
  if (!root) return;

  // Feeds the "Recently viewed" drawer (blocks/_recently_viewed_products.liquid, element in global.js)
  try {
    const viewedId = parseInt(root.dataset.productId, 10);
    if (viewedId) {
      const key = '_halo_recently_viewed';
      const viewed = JSON.parse(localStorage.getItem(key) || '[]').filter((id) => id !== viewedId);
      viewed.unshift(viewedId);
      localStorage.setItem(key, JSON.stringify(viewed.slice(0, 25)));
    }
  } catch (error) {
    // storage unavailable (private mode); the drawer simply stays empty
  }

  const variants = JSON.parse(root.querySelector('[data-gk-variants]').textContent);
  const form = root.querySelector('form');
  const idInput = root.querySelector('[data-gk-variant-id]');
  const addBtn = root.querySelector('[data-gk-add]');
  const buyNow = root.querySelector('[data-gk-buynow]');
  const addLabel = root.querySelector('[data-gk-add-label]');
  const errorEl = root.querySelector('[data-gk-error]');
  const toast = root.querySelector('[data-gk-toast]');
  const toastText = root.querySelector('[data-gk-toast-text]');
  const optionSets = [...root.querySelectorAll('[data-gk-option]')];
  const priceNow = root.querySelector('[data-gk-price-now]');
  const priceMrp = root.querySelector('[data-gk-price-mrp]');
  const priceCompare = root.querySelector('[data-gk-price-compare]');
  const priceOff = root.querySelector('[data-gk-price-off]');
  const sku = root.querySelector('[data-gk-sku]');
  const track = root.querySelector('.gk-pdp-gallery__track');
  const counter = root.querySelector('[data-gk-gallery-count]');
  const mobile = window.matchMedia('(max-width: 1023px)');

  const selection = () => optionSets.map((set) => {
    const checked = set.querySelector('input:checked');
    return checked ? checked.value : undefined;
  });
  const findVariant = (options) => variants.find((v) => v.options.every((o, i) => o === options[i]));

  const updateOptionStates = (current) => {
    optionSets.forEach((set, index) => {
      const isSize = set.classList.contains('gk-opt--size');
      set.querySelectorAll('.gk-opt__item').forEach((item) => {
        const value = item.querySelector('input').value;
        const trial = current.slice();
        trial[index] = value;
        const exact = trial.every((o) => o !== undefined) ? findVariant(trial) : null;
        const candidates = variants.filter((v) => v.options.every((o, i) => i === index ? o === value : o === trial[i]));
        const available = exact ? exact.available : candidates.some((v) => v.available);
        item.classList.toggle('is-unavailable', !available);

        const left = item.querySelector('[data-gk-left]');
        if (!left) return;
        const qty = exact && exact.available ? exact.qty : null;
        const low = isSize && qty !== null && qty > 0 && qty <= 5;
        left.hidden = !low;
        if (low) left.textContent = `${qty} left`;
      });
    });
  };

  const scrollGalleryTo = (mediaId) => {
    if (!mediaId || !track || !mobile.matches) return;
    const item = track.querySelector(`[data-media-id="${mediaId}"]`);
    if (item) track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
  };

  const update = (changed) => {
    const current = selection();
    updateOptionStates(current);
    const variant = findVariant(current);

    if (!variant) {
      addBtn.disabled = true;
      if (buyNow) buyNow.disabled = true;
      addLabel.textContent = 'Unavailable';
      return;
    }

    idInput.value = variant.id;
    priceNow.textContent = variant.price;
    priceCompare.textContent = variant.compare;
    priceOff.textContent = `(${variant.saved} OFF)`;
    priceMrp.hidden = !variant.onSale;
    priceOff.hidden = !variant.onSale;
    if (sku && variant.sku) sku.textContent = variant.sku;
    addBtn.disabled = !variant.available;
    if (buyNow) buyNow.disabled = !variant.available;
    addLabel.textContent = variant.available ? 'Add to bag' : 'Sold out';
    errorEl.hidden = true;

    if (changed) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      scrollGalleryTo(variant.media);
    }
  };

  optionSets.forEach((set) => set.addEventListener('change', () => update(true)));
  update(false);

  const refreshCartCount = async () => {
    try {
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      const link = document.querySelector('.gk-actions__cart');
      if (!link) return;
      let badge = link.querySelector('[data-gk-cart-count]');
      if (!badge && cart.item_count > 0) {
        badge = document.createElement('b');
        badge.setAttribute('data-gk-cart-count', '');
        link.appendChild(badge);
      }
      if (badge) {
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count === 0;
      }
    } catch (error) {
      // The count refreshes on the next page load.
    }
  };

  let toastTimer;
  const showToast = (text) => {
    toastText.textContent = text;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 4500);
  };

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (addBtn.disabled) return;

    const original = addLabel.textContent;
    addBtn.disabled = true;
    addLabel.textContent = 'Adding...';
    errorEl.hidden = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: idInput.value, quantity: 1 }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Could not add this item.');
      addLabel.textContent = 'Added';
      refreshCartCount();
      if (window.gillkartCart) {
        window.gillkartCart.open('Added to your bag');
      } else {
        showToast('Added to bag');
      }
      setTimeout(() => {
        addBtn.disabled = false;
        addLabel.textContent = original;
      }, 1600);
    } catch (error) {
      errorEl.textContent = error.message;
      errorEl.hidden = false;
      addBtn.disabled = false;
      addLabel.textContent = original;
    }
  });

  if (buyNow) {
    buyNow.addEventListener('click', async () => {
      if (buyNow.disabled) return;
      errorEl.hidden = true;

      const original = buyNow.textContent;
      buyNow.disabled = true;
      buyNow.textContent = 'Redirecting...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: idInput.value, quantity: 1 }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Could not add this item.');
        window.location.href = '/checkout';
      } catch (error) {
        errorEl.textContent = error.message;
        errorEl.hidden = false;
        buyNow.disabled = false;
        buyNow.textContent = original;
      }
    });
  }

  if (track && counter) {
    track.addEventListener('scroll', () => {
      if (!mobile.matches) return;
      const items = track.children.length;
      const index = Math.round(track.scrollLeft / track.clientWidth);
      counter.textContent = `${Math.min(index + 1, items)} / ${items}`;
    }, { passive: true });
  }

  const zoomSources = [...root.querySelectorAll('[data-gk-zoom]')].map((el) => el.dataset.gkZoom);
  let lightbox;
  let lightboxIndex = 0;

  const closeLightbox = () => {
    if (!lightbox) return;
    lightbox.remove();
    lightbox = null;
    document.documentElement.classList.remove('gk-scroll-lock');
  };

  const renderLightbox = () => {
    lightbox.querySelector('img').src = zoomSources[lightboxIndex];
    lightbox.querySelector('[data-gk-lb-count]').textContent = `${lightboxIndex + 1} / ${zoomSources.length}`;
  };

  const step = (delta) => {
    lightboxIndex = (lightboxIndex + delta + zoomSources.length) % zoomSources.length;
    renderLightbox();
  };

  const openLightbox = (index) => {
    lightboxIndex = index;
    lightbox = document.createElement('div');
    lightbox.className = 'gk-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Product images');
    lightbox.innerHTML = `
      <button type="button" class="gk-lightbox__close" aria-label="Close">&times;</button>
      <button type="button" class="gk-lightbox__nav gk-lightbox__nav--prev" aria-label="Previous image">&lsaquo;</button>
      <img alt="">
      <button type="button" class="gk-lightbox__nav gk-lightbox__nav--next" aria-label="Next image">&rsaquo;</button>
      <span class="gk-lightbox__count" data-gk-lb-count></span>`;
    lightbox.addEventListener('click', (event) => {
      if (event.target.closest('.gk-lightbox__close') || event.target === lightbox) closeLightbox();
      else if (event.target.closest('.gk-lightbox__nav--prev')) step(-1);
      else if (event.target.closest('.gk-lightbox__nav--next')) step(1);
    });
    document.body.appendChild(lightbox);
    document.documentElement.classList.add('gk-scroll-lock');
    renderLightbox();
    lightbox.querySelector('.gk-lightbox__close').focus();
  };

  root.querySelectorAll('[data-gk-zoom]').forEach((button, index) => {
    button.addEventListener('click', () => openLightbox(index));
  });

  const similar = root.querySelector('[data-gk-similar]');
  if (similar && similar.dataset.url) {
    fetch(similar.dataset.url)
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        if (!html.trim()) return;
        const items = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-gk-similar-items]');
        if (!items) return;
        similar.querySelector('[data-gk-similar-content]').replaceChildren(...items.childNodes);
        similar.hidden = false;

        // Avoid showing the same product in both rows.
        const shown = new Set([...similar.querySelectorAll('.gk-product__link')].map((a) => a.getAttribute('href').split('?')[0]));
        root.querySelectorAll('[data-gk-related] .gk-product').forEach((tile) => {
          const link = tile.querySelector('.gk-product__link');
          if (link && shown.has(link.getAttribute('href').split('?')[0])) tile.remove();
        });
      })
      .catch(() => {});
  }

  document.addEventListener('keydown', (event) => {
    if (!lightbox) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft') step(-1);
    if (event.key === 'ArrowRight') step(1);
  });
})();
